import { render, staticRenderFns } from "./AssessmentFilter.vue?vue&type=template&id=4451d166&scoped=true"
import script from "./AssessmentFilter.vue?vue&type=script&lang=js"
export * from "./AssessmentFilter.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFilter.vue?vue&type=style&index=0&id=4451d166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451d166",
  null
  
)

export default component.exports